//*** Lib */
import Cookies from 'universal-cookie';
import { decryptStorageData, decryptStorageDataSSO, encryptSotrageData, encryptSotrageDataSSO } from '../../services/CryptoService';

const cookies = new Cookies();

const authCookieName = 'CMAuthUser';
const tokenCookieName = 'CMToken';

export const IsCookieEncryption = true;

export const createCookie = (props) => {
    let cookieValue = encryptSotrageData(props.cookieValue);
    let cookieName = props.cookieName;
    cookies.set(cookieName, cookieValue,
        {
            path: props.path,
            maxAge: props.expirationTime * 60,
        });
};

export const createCookieSSO = (props) => {
    let cookieValue = encryptSotrageDataSSO(props.cookieValue);
    let cookieName = props.cookieName;
    cookies.set(cookieName, cookieValue,
        {
            path: props.path,
            maxAge: props.expirationTime * 60,
        });
};

//Store cookie
export const setCookie = (props) => {
    let cookieValue = encryptSotrageData(props.cookieValue);
    let cookieName = props.cookieName;
    cookies.set(cookieName, cookieValue);
}

export function getCookie(cookieName, doNotParse = false) {
    const cookieValue = cookies.get(cookieName, { doNotParse: doNotParse })
    if (cookieValue) {
        return decryptStorageData(cookieValue);
    }
    else {
        return null;
    }
}

export const getAllCookies = (doNotParse = false) => {
    const cookieValue = cookies.getAll({ doNotParse: doNotParse });
    return decryptStorageData(cookieValue);
};

export const removeCookie = (cookieName, options = {}) => {
    cookies.remove(cookieName, options);
};

export const removeAllCookies = () => {
    Object.keys(cookies.cookies).forEach(element => {
        cookies.remove(element, {});
    });
};

//Check cookie exist or not
export const isCookieExist = (cookieName) => {
    const cookieDetail = getCookie(cookieName);
    if (cookieDetail) {
        return true;
    }
    return false;
}

export const setAuthPropsSSO = (data) => {
    if (data?.message === null) {
        const authProps = {
            cookieName: authCookieName,
            cookieValue: data,
            expirationTime: data.responseItem.responseContent.sessionTimeout
        }
        createCookieSSO(authProps);
        setTokenPropsSSO(data.responseItem.responseContent.token);
    } else {
        const authProps = {
            cookieName: authCookieName,
            cookieValue: data,
            expirationTime: data?.sessionTimeout
        }
        createCookieSSO(authProps);
        setTokenPropsSSO(data.token);
    }
}

export const setTokenPropsSSO = (data) => {
    const tokenProps = {
        cookieName: tokenCookieName,
        cookieValue: data
    }
    setCookieSSO(tokenProps);
}

export const setCookieSSO = (props) => {
    let cookieValue = props.cookieValue;
    let cookieName = props.cookieName;
    cookieValue = encryptSotrageDataSSO(cookieValue, 1);
    cookies.set(cookieName, cookieValue);
}

export const getAuthPropSSO = () => {
    return getCookieSSO(authCookieName);
}

export function getCookieSSO(cookieName, doNotParse = false) {
    if (IsCookieEncryption) {
        const cookieValue = cookies.get(cookieName, { doNotParse: doNotParse })
        if (cookieValue)
            return decryptStorageDataSSO(cookieValue, true);
    }
    else {
        return cookies.get(cookieName, { doNotParse: doNotParse })
    }
    return undefined;
}